import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import "./assets/css/dev-responsive.css";

import "./assets/css/custom.css";
import "./assets/css/dev.css";
import "./assets/css/responsive.css";

import "react-toastify/dist/ReactToastify.css";

import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import MainScreen from "./components/MainScreen/MainScreen";
import GetStartedScrn from "./components/GetStartedScreen/GetStartedScrn";
import Onboarding from "./components/OnboardingScreen/Onboarding";
import LandingPage from "./components/LandingPage/LandingPage";
import { useDispatch, useSelector } from "react-redux";
import ForgetPassword from "./components/ForgetPassword";
import GetStartedLandingPage from "./GetStartedLandingPage";
import { LoginRouteAction } from "./Redux/LoginRouteAction";

function App() {
  const selector = useSelector((state) => state.rootReducer);
  const loginUrl = useSelector((state) => state.LoginRouteReducer);
  const userType = selector?.user?.user_type;
  const paymentStatus = selector?.user?.payment_status;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(LoginRouteAction(false));
  }, []);

  // const [isLoggedIn, setIsLoggedIn] = useState(
  //   // localStorage.getItem("token") ? true : false
  //   selector.isLoggedIn ? true : false
  // );

  // useEffect(() => {
  //   // Simulate retrieving login status from local storage or a server
  //   // const storedUser = localStorage.getItem("token") ? true : false;
  //   const storedUser = selector.isLoggedIn ? true : false;
  //   setIsLoggedIn(storedUser);
  // }, []);

  return (
    <>
      {
        !selector.isLoggedIn && !loginUrl.loginUrl ? (
          <Routes>
            <Route
              path="/forget_password/:token"
              element={<ForgetPassword />}
            />
            <Route path="/get-started" element={<GetStartedLandingPage />} />

            <Route path="/*" element={<Navigate to="/get-started" replace />} />
            {/* <Route path="/login" element={<GetStartedScrn />} /> */}
            {/* <Route path="/" element={<LandingPage />} /> */}
          </Routes>
        ) : userType !== "guest" &&
          selector?.user?.verfied &&
          !loginUrl.loginUrl ? (
          <Routes>
            <Route path="/journey" element={<MainScreen />} />
            <Route path="/payment/:paymentId" element={<MainScreen />} />
            {/* <Route path="/onboarding" element={<Onboarding />} /> */}
            <Route
              path="/*"
              element={
                <Navigate
                  to={
                    selector.isLoggedIn && userType === "admin"
                      ? "/journey"
                      : userType === "user" && paymentStatus === true
                      ? "/journey"
                      : "/journey"
                  }
                  replace
                />
              }
            />
            {/* <Route path="/playground" element={<MainScreen />} /> */}
            <Route path="/universities" element={<MainScreen />} />
            <Route path="/settings" element={<MainScreen />} />
            <Route path="/dashboard" element={<MainScreen />} />

            {userType === "user" && (
              <Route path="/story" element={<MainScreen />} />
            )}
            <Route path="/scholarship" element={<MainScreen />} />
            {userType === "admin" && (
              <Route path="/users" element={<MainScreen />} />
            )}
            <Route path="/news" element={<MainScreen />} />
            <Route path="/voice" element={<MainScreen />} />
          </Routes>
        ) : (
          (userType === "guest" ||
            (userType !== "guest" &&
              !selector?.user?.verfied &&
              !loginUrl.loginUrl)) && (
            <Routes>
              <Route
                path="/*"
                element={<Navigate to="/get-started" replace />}
              />
              <Route
                path="/forget_password/:token"
                element={<ForgetPassword />}
              />
              <Route path="/get-started" element={<GetStartedLandingPage />} />
            </Routes>
          )
        )
        // : (
        //   userType !== "guest" &&
        //   !selector?.user?.verfied && (
        //     <Routes>
        //       <Route
        //         path="/*"
        //         element={<Navigate to="/get-started" replace />}
        //       />
        //       <Route path="/get-started" element={<GetStartedLandingPage />} />
        //     </Routes>
        //   )
        // )
      }
    </>
  );
}

export default App;

// return (
//   <>
//     {!selector.isLoggedIn ? (
//       <Routes>
//         <Route path="/*" element={<Navigate to="/" replace />} />
//         <Route path="/login" element={<GetStartedScrn />} />
//         <Route path="/" element={<LandingPage />} />
//       </Routes>
//     ) : (
//       !selector.onboarding ? (
//         <Routes>
//           <Route path="/onboarding" element={<Onboarding />} />
//         </Routes>
//       ) : (
//         <Routes>
//           <Route path="/journey" element={<MainScreen />} />
//           <Route path="/*" element={<Navigate to="/playground" replace />} />
//           <Route path="/playground" element={<MainScreen />} />
//           <Route path="/universities" element={<MainScreen />} />
//           <Route path="/settings" element={<MainScreen />} />
//           <Route path="/dashboard" element={<MainScreen />} />
//           <Route path="/users" element={<MainScreen />} />
//         </Routes>
//       )
//     )}
//   </>
// );
